import * as bootstrap from "bootstrap";

$('.js-select-2').select2();

const togglePasswords = document.querySelectorAll(".password-toggle-icon i");

for (let i = 0; i < togglePasswords.length; ++i) {
    const togglePassword = togglePasswords[i];
    togglePassword.addEventListener("click", function (e) {
        const fieldId = e.target.getAttribute('data-field_id');
        const passwordField = document.getElementById(fieldId);

        if (passwordField.type === "password") {
            passwordField.type = "text";
            togglePassword.classList.remove("fa-eye");
            togglePassword.classList.add("fa-eye-slash");
        } else {
            passwordField.type = "password";
            togglePassword.classList.remove("fa-eye-slash");
            togglePassword.classList.add("fa-eye");
        }
    });
}

$(document).ready(function () {
    $('#register-form').submit(function (e){
        $('.submit-once').prop('disabled', true);
    });
});

let bsModal;
let cancelToken;

$(document).on('click', '.js-item-modal', function(event) {
    event.preventDefault();

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'get',
        url: $(this).attr('href'),
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        $('.js-modals-container').html(response.data.modal);

        $('#default-modal').ready(function () {
            let modalElement = $('#default-modal')[0];

            bsModal = new bootstrap.Modal(modalElement, {
                backdrop: 'static'
            });

            bsModal.show();

            modalElement.addEventListener('shown.bs.modal', () => {
            });
        });
    }).catch(() => {
    });
});

window.onRecaptcha = function(token) {
    const form = document.querySelector('.g-recaptcha-form');
    if(form) {
        form.submit();
    }
}
